import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // scroll function that prefers hash target, otherwise top
    const doScroll = () => {
      if (hash) {
        const id = hash.replace(/^#/, "");
        const el = document.getElementById(id) || document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
          return;
        }
      }
      // normal: scroll to top
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Run after paint to ensure new content is in DOM
    requestAnimationFrame(() => {
      requestAnimationFrame(doScroll);
    });

    // Fallback: run shortly after in case of async content
    const t = setTimeout(doScroll, 60);

    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
